const AUTH_KEYS = [
  "accessToken",
  "refreshToken",
  "auth",
  "authSessionExpiresAt",
] as const;

export const REMEMBER_SESSION_DAYS = 30;
export const REMEMBER_SESSION_MS =
  REMEMBER_SESSION_DAYS * 24 * 60 * 60 * 1000;

export const clearAuthSession = () => {
  AUTH_KEYS.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

export const getAuthStorage = (): Storage | null => {
  if (
    localStorage.getItem("accessToken") &&
    localStorage.getItem("refreshToken") &&
    localStorage.getItem("auth")
  ) {
    return localStorage;
  }

  if (
    sessionStorage.getItem("accessToken") &&
    sessionStorage.getItem("refreshToken") &&
    sessionStorage.getItem("auth")
  ) {
    return sessionStorage;
  }

  return null;
};

export const getSessionItem = (key: (typeof AUTH_KEYS)[number]) =>
  getAuthStorage()?.getItem(key) ?? null;

export const saveAuthSession = ({
  accessToken,
  refreshToken,
  auth,
  rememberMe,
}: {
  accessToken: string;
  refreshToken: string;
  auth: string;
  rememberMe: boolean;
}) => {
  clearAuthSession();
  const storage = rememberMe ? localStorage : sessionStorage;

  storage.setItem("accessToken", accessToken);
  storage.setItem("refreshToken", refreshToken);
  storage.setItem("auth", auth);

  if (rememberMe) {
    storage.setItem(
      "authSessionExpiresAt",
      String(Date.now() + REMEMBER_SESSION_MS)
    );
  }
};

export const ensureRememberedSessionExpiry = (storage: Storage) => {
  if (storage !== localStorage) {
    return true;
  }

  const storedExpiry = storage.getItem("authSessionExpiresAt");
  if (!storedExpiry) {
    storage.setItem(
      "authSessionExpiresAt",
      String(Date.now() + REMEMBER_SESSION_MS)
    );
    return true;
  }

  const expiresAt = Number(storedExpiry);
  return Number.isFinite(expiresAt) && expiresAt > Date.now();
};
